import { CardGroup } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { WidgetFC } from '@swf/core/types/Widget';
import { Message, TryAgainMessage } from '@swf/sports/components';

import {
  TXTWCL_All_Competitions,
  TXTWCL_There_are_no_competitions_avai_ELL
} from './SportsCompetitionsWidget.messages.json';
import Group from './components/Group/Group';
import LoadingState from './components/LoadingState/LoadingState';
import { sportsCompetitionsWidgetModel, useSportsCompetitionsWidget } from './model';

const SportsCompetitionsWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsCompetitionsWidget();
  const allCompetitionIds = useSelector(widgetSelect.allCompetitionIds);
  const groups = useSelector(widgetSelect.groups);
  const errorCode = useSelector(widgetSelect.errorCode);
  const isLoading = useSelector(widgetSelect.isLoading);

  const { formatMessage } = useRegulatoryIntl();

  if (isLoading) {
    return <LoadingState />;
  }

  if (errorCode === 'NOT_FOUND') {
    return <Message message={<Translation {...TXTWCL_There_are_no_competitions_avai_ELL} />} />;
  }

  if (errorCode) {
    return <TryAgainMessage />;
  }

  if (!allCompetitionIds.length) {
    return <Message message={<Translation {...TXTWCL_There_are_no_competitions_avai_ELL} />} />;
  }

  return (
    <CardGroup flushOnMobile padded>
      {groups.map(({ name, competitionIds }) => (
        <Group key={name} openInitially competitionIds={competitionIds} name={name} />
      ))}

      <Group
        openInitially
        competitionIds={allCompetitionIds}
        name={formatMessage(TXTWCL_All_Competitions)}
      />
    </CardGroup>
  );
};

SportsCompetitionsWidget.model = sportsCompetitionsWidgetModel;

export default withWidgetTestId(SportsCompetitionsWidget, 'sports-competitions');
